export const partnerConnections = {
  "accountStatus.active": "Đang hoạt động",
  "accountStatus.suspended": "Tạm ngừng",
  "accountStatus.closed": "Đã đóng",
  bkavConnectionScope:
    "Cấu hình tại HQ là địa chỉ dịch vụ dùng chung. Partner GUID và token của BKAV thuộc từng doanh nghiệp, được khai báo trong Bube eInvoice; không nhập vào đây.",
  partyLookupSourceScope:
    "Nguồn tra cứu MST dùng chung cho MỌI workspace: tài khoản BKAV này thuộc Bube, khách không thấy và không phải kết nối nhà cung cấp nào. Lưu → Kiểm thử (tra MST thật bằng khoá vừa nhập; không đạt thì không kích hoạt được) → kích hoạt → gán TỪNG app dùng nó (bube-einvoice, bube-shop — độc lập như Tingee). bube-shop tra bằng nguồn gán cho shop trước, không được mới hỏi bube-einvoice. Sau khi gán, bấm Thử tra bên dưới để kiểm đường hq → bube-einvoice trước khi mở cho người dùng.",
  partyLookupSourceTitle: "Thử tra MST",
  partyLookupSourceHelp:
    "Chạy một lượt tra thật bằng đúng cấu hình bube-einvoice đang nhận (bỏ bộ đệm). Cấu hình mới phải được gán cho bube-einvoice thì mới thấy ở đây.",
  partyLookupSourceTaxCode: "Mã số thuế",
  partyLookupSourceRun: "Thử tra",
  partyLookupSourceRunning: "Đang tra…",
  partyLookupSourceInvalid: "Mã số thuế gồm 10 hoặc 12 chữ số (có thể kèm -001).",
  partyLookupSourceNotConfigured:
    "bube-einvoice chưa nhận nguồn tra nào đủ Partner GUID, token và URL gốc, hoặc gán đang tắt. Kiểm thử và gán cho bube-einvoice rồi thử lại.",
  partyLookupSourceOk: "Nguồn trả lời ({environment}, {ms} ms)",
  partyLookupSourceFound: "Tìm thấy",
  partyLookupSourceNotFound: "Nguồn chạy được nhưng không có doanh nghiệp này.",
  partyLookupSourceFailedTimeout: "Quá thời gian chờ ({environment}, {ms} ms). Kiểm tra mạng tới BKAV hoặc URL gốc.",
  partyLookupSourceFailedProvider: "BKAV từ chối hoặc lỗi ({environment}, {ms} ms, mã {code}). Kiểm tra Partner GUID, token và môi trường.",
  partyLookupSourceName: "Tên",
  partyLookupSourceAddress: "Địa chỉ",
  partyLookupSourceStatus: "Trạng thái",
  editorHelp:
    "Lưu tạo một phiên bản chờ. Cấu hình đang phục vụ giữ nguyên cho tới khi kiểm thử đạt và bạn kích hoạt phiên bản mới.",
  officialSettings: "Địa chỉ kết nối cố định",
  officialSettingsHelp:
    "Được quy định theo nhà cung cấp và môi trường đã chọn; không cần nhập lại.",

  setupSections: "Các bước thiết lập kết nối",
  configurationTab: "Cấu hình kết nối",
  applicationsTab: "Ứng dụng sử dụng",
  selectAccount: "Chọn tài khoản nhà cung cấp",
  selectConnection: "Chọn kết nối",
  connectionCount: "{count} kết nối",
  versionTrace: "Thông tin tạo phiên bản",
  maintenanceActions: "Ngừng kết nối và khóa cũ",
  maintenanceHelp:
    "Chỉ dùng khi bảo trì hoặc thu hồi kết nối. Mỗi thao tác cần lý do và xác nhận lại tên.",
  bindingsHelp:
    "Chọn kết nối đã kích hoạt cho từng ứng dụng. Công tắc là lựa chọn chờ; bấm Lưu gán để áp dụng. Bật cấu hình vẫn cần đủ quyền mở dịch vụ.",

  olderVersions: "Phiên bản trước ({count})",
  connectionActive: "Đang hoạt động",
  testReport: "Báo cáo kiểm thử",
  settings: "Thông số phiên bản",
  accounts: "Tài khoản nhà cung cấp",
  intro: "Tạo phiên bản → kiểm thử → kích hoạt. Kiểm thử đạt không tự đưa vào sử dụng.",
  loading: "Đang tải kết nối…",
  reload: "Tải lại",
  createAccount: "Thêm tài khoản",
  displayName: "Tên tài khoản",
  purpose: "Mục đích (không đổi sau khi tạo)",
  platform: "Nền tảng — phục vụ ứng dụng",
  lab: "Phòng thử — chỉ dùng thử nội bộ",
  owner: "Chủ tài khoản",
  ownerId: "Mã chủ tài khoản",
  organization: "Tổ chức Bube",
  user: "Nhân viên",
  team: "Nhóm",
  createConnection: "Thêm kết nối",
  name: "Tên kết nối",
  noAccounts: "Chưa có tài khoản nhà cung cấp.",
  noConnections: "Chưa có kết nối ở môi trường này.",
  noVersions: "Chưa có phiên bản.",
  save: "Lưu phiên bản chờ",
  create: "Tạo",
  cancel: "Huỷ",
  edit: "Tạo phiên bản mới",
  history: "Lịch sử phiên bản",
  active: "Đang sử dụng",
  candidate: "Phiên bản chờ",
  historical: "Lịch sử",
  certified: "Đã chứng nhận",
  pending: "Chưa chứng nhận",
  grandfathered: "Giữ chứng nhận di trú",
  test: "Kiểm thử",
  testFailed: "Lần thử gần nhất thất bại",
  activate: "Kích hoạt",
  restore: "Khôi phục thành phiên bản mới",
  cutGrace: "Cắt ân hạn",
  disable: "Ngừng kết nối",
  note: "Lý do (ít nhất 5 ký tự)",
  typedName: "Gõ lại tên kết nối để xác nhận",
  activateEffect:
    "Phiên bản được chọn sẽ phục vụ ứng dụng. Khoá cũ giữ ân hạn trừ khi chọn cắt ngay.",
  restoreEffect: "Tạo phiên bản chờ mới; lịch sử và phiên bản đang phục vụ không bị sửa.",
  cutEffect: "Khoá cũ hết quyền nhận tin trong ân hạn.",
  disableEffect: "Máy chủ từ chối nếu kết nối còn gán, tuyến đang chạy hoặc ân hạn.",
  waive: "Cắt ân hạn khoá cũ ngay",
  busy: "Đang xử lý…",
  failed: "Không thực hiện được.",
  conflict: "Dữ liệu vừa thay đổi. Tải lại và kiểm tra trước khi gửi lại.",
  emptySecret: "Để trống để giữ bí mật hiện có",
  clearSecret: "Xoá bí mật ở phiên bản mới",
  hubOnly: "Chỉ lưu ở HQ",
  bindings: "Gán ứng dụng",
  activeBinding: "Đang dùng — gửi yêu cầu mới",
  draining: "Đang ân hạn — chỉ nhận tin từ đối tác",
  deadline: "Hết hạn",
  enabled: "Bật",
  assign: "Lưu gán",
  choose: "Chọn kết nối",
  mailRoute: "Chọn tuyến mail qua cổng kiểm",
  labLink: "Mở phòng thử",
  pricing: "Giá dùng chung theo tài khoản và môi trường nhà cung cấp",
  version: "Phiên bản",
  readOnly: "Bạn đang ở chế độ chỉ xem.",
  noActive: "Chưa có phiên bản đang sử dụng",
  status: "Trạng thái",
  draft: "Bản nháp",
  tested: "Đã thử, chưa kích hoạt",
  disabled: "Đã ngừng",
  accountState: "Trạng thái tài khoản",
};
